import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LockDesigner from 'Vue/containers/LockDesigner.vue';
import Question from 'Vue/components/lockDesigner/Question.vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/get-inspired/lock-designer/quiz/:question',
        name: 'Lock Designer Question',
        component: Question,
    },
    {
        path: '/get-inspired/lock-designer/quiz',
        //redirect: '/get-inspired/lock-designer/quiz',
        name: 'Lock Designer',
        component: LockDesigner,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
